import {TimelineLite} from "gsap";
import {PearlHarbor} from "../PearlHarbor";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {PearlHarborSymbol} from "./PearlHarborSymbol";
import {ISymbolData} from "../server/PearlHarborModel";
import {PearlHarborSoundManager} from "../sound/PearlHarborSoundManager";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {PearlHarborGameConfig} from "../PearlHarborGameConfig";

export class PearlHarborTargetSymbol extends PearlHarborSymbol {
    private readonly animationName: string[] = ["idle", "land", "land_inside", "mult_up", "winattention"];
    public readonly animationConfig = {"add_sword": 19, "landing": 13, "split": 30, "turningWild": 22};

    private _landingAnimation: PIXI.spine.Spine;
    private _hasLanded: boolean;
    private _isSpent: boolean;

    constructor(symbolData: ISymbolData) {
        super(symbolData);
        this._isSpent = false;
        this._hasLanded = false;
    }

    public updateMultiplier(): TimelineLite {
        const spineObj: PIXI.spine.Spine = this._landingAnimation;
        spineObj.position.set(0, 0);
        const tl: TimelineLite = super.updateMultiplier();
        tl.add([
            () => {
                this.addChild(spineObj);
                this.currentStateSprite.visible = false;
                this.addChild(this._sizeMultiplier);
            },
            new SpineTween(spineObj, 0, `mult_up`)
        ], 0)

        tl.add(() => {
            this.currentStateSprite.visible = true;
            this.removeChild(spineObj);
        });
        return tl;
    }

    public playTargetLandingAnim(): TimelineLite {
        this._textureName = `TARGET_SPENT${this._isSplit ? "_H" : ""}`;
        this.symbolName =`TARGET_SPENT${this._isSplit ? "_H" : ""}`;

        const tl: TimelineLite = new TimelineLite();
        if (!PearlHarbor.model.data.wasFeatureBuy) {
            this._landingAnimation = new PIXI.spine.Spine(PearlHarbor.assetLoader.getSpineAsset(this._isSplit ? "target_h" : "target"));
            const spineObj: PIXI.spine.Spine = this._landingAnimation;
            NolimitApplication.getLayerByName("XSplitAnimation")!.addChild(spineObj);
            spineObj.position.set((this._reelId) * PearlHarborGameConfig.symbolWidth, (this._reelTargetPosition + 1) * PearlHarborGameConfig.symbolHeight * 0.5-(this._isSplit?24:0));

            tl.add([
                () => {
                    this.currentStateSprite.visible = false;
                    PearlHarborSoundManager.playTargetToWild();
                },
                new SpineTween(spineObj, 0, `land${this.isActivated ? "_inside" : ""}`)
            ]);
            tl.add(() => {
                this.currentStateSprite.visible = true;
                NolimitApplication.getLayerByName("XSplitAnimation")!.removeChild(spineObj);
            });
            tl.add(() => {
                this._hasLanded = true;
                this.currentStateSprite.texture = PearlHarbor.assetLoader.getTextures(`${this._textureName}/${this._textureName}`)[0];
            });
        }else{
            this._hasLanded = true;
            this.currentStateSprite.texture = PearlHarbor.assetLoader.getTextures(`${this._textureName}/${this._textureName}`)[0];
            this.symbolName =`TARGET_SPENT${this._isSplit ? "_H" : ""}`;
        }
        return tl;
    }

    public fallOut():void{
        if(this._landingAnimation && !this._hasLanded){
            this.currentStateSprite.texture = PearlHarbor.assetLoader.getTextures(`${this._textureName}/${this._textureName}`)[0];
            this.currentStateSprite.visible = true;
            NolimitApplication.getLayerByName("XSplitAnimation")!.removeChild(this._landingAnimation);
        }
    }

    public remove() {
        if(this._landingAnimation){
            this._landingAnimation.destroy();
        }
        super.remove();
    }

}